import { amenityIdZodSchema } from "@@/shared/acquire/resources/resource-accommodation/amenities/amenity-id";
import { amenityTypeZodEnum } from "@@/shared/acquire/resources/resource-accommodation/amenities/amenity-type";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { iconNameZodString } from "@@/shared/icon-name";
import { idZodSchema } from "@@/shared/id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import {
    requiredTranslatableZodSchema,
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const amenityAddCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("AMENITY_ADD_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    amenityId: amenityIdZodSchema.optional(),
    type: amenityTypeZodEnum,
    title: requiredTranslatableZodSchema,
    shortDescription: translatableZodSchema.optional(),
    description: translatableZodSchema.optional(),
    providerId: providerIdZodSchema.optional(),
    iconName: iconNameZodString.optional(),
});

type AmenityAddCommand = z.infer<typeof amenityAddCommandZodObject>;

const amenityAddCommandFactoryParamsZodObject = amenityAddCommandZodObject.omit(
    {
        _id: true,
        _type: true,
        _createdAt: true,
    },
);
type FactoryParams = z.infer<typeof amenityAddCommandFactoryParamsZodObject>;

const amenityAddCommandFactory = (params: FactoryParams) => {
    const amenityAddCommand: AmenityAddCommand = {
        ...params,
        _id: generateId({ prefix: "amenity_add_command__" }),
        _type: "AMENITY_ADD_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return amenityAddCommand;
};

export {
    amenityAddCommandFactory,
    amenityAddCommandFactoryParamsZodObject,
    amenityAddCommandZodObject,
};
export type {
    AmenityAddCommand,
    FactoryParams as AmenityAddCommandFactoryParams,
};
